import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert } from '@mui/material';

export const ErrorMsg = (p: { err: Error; className?: string }) => {
  return (
    <Alert severity="error" icon={<ErrorOutlineIcon />} className={p.className}>
      {p.err.message || p.err.constructor.name}
    </Alert>
  );
};
